import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Input from '../../../core/Input';
import InputDate from '../../../core/InputDate';

import { Trash, ArrowLeft } from '../../../../../assets/images/index';

import {
  StyledLabel,
  StyledBoxInputEducation,
  StyledBoxModuleAlignTop,
  StyledOrderItem,
  StyledIcon
} from './style';

import { WrapperCollapsed, StyledIconDrop } from './styleEducation';

import { CHILDREN } from '../../../../constants/literals/modals';

const ChildrenItem = ({
  expanded,
  onChangeNameInput,
  onChangeSurnameInput,
  onChangeBirthdateInput,
  onClickExpand,
  onClickDelete,
  onClickDown,
  onClickUp,
  order,
  name,
  surname,
  birthdate,
  errorName,
  errorSurname,
  errorBirthdate
}) => {
  useEffect(() => {}, []);

  return (
    <StyledBoxModuleAlignTop className="content-education">
      <StyledOrderItem
        order={order}
        onClickDown={onClickDown}
        onClickUp={onClickUp}
      />
      <StyledBoxInputEducation>
        <StyledIconDrop
          svg={ArrowLeft}
          size="s"
          hover
          onClick={onClickExpand}
          expanded={expanded}
        />

        <StyledLabel>{CHILDREN.NAME_LABEL}</StyledLabel>
        <Input
          value={name}
          onChange={onChangeNameInput}
          errorTitle={errorName}
        />

        <WrapperCollapsed expanded={expanded}>
          <StyledLabel>{CHILDREN.SURNAME_LABEL}</StyledLabel>
          <Input
            value={surname}
            onChange={onChangeSurnameInput}
            errorTitle={errorSurname}
          />
          <StyledLabel>{CHILDREN.BIRTHDATE_LABEL}</StyledLabel>
          <InputDate
            id="inputDate"
            format="YYYY-MM-DD"
            className="form-input-date"
            onChange={onChangeBirthdateInput}
            placeholder={birthdate}
            errorTitle={errorBirthdate}
          />
        </WrapperCollapsed>
      </StyledBoxInputEducation>
      <StyledIcon svg={Trash} hover onClick={onClickDelete} />
    </StyledBoxModuleAlignTop>
  );
};

ChildrenItem.propTypes = {
  expanded: PropTypes.bool,
  onClickExpand: PropTypes.func,
  onClickDelete: PropTypes.func,
  onClickDown: PropTypes.func,
  onClickUp: PropTypes.func,
  order: PropTypes.number,
  name: PropTypes.string,
  birthdate: PropTypes.string,
  surname: PropTypes.string,
  errorName: PropTypes.string,
  errorSurname: PropTypes.string,
  errorBirthdate: PropTypes.string
};

ChildrenItem.defaultProps = {
  expanded: true
};

export default ChildrenItem;
